import { Text } from '@lmc/ui-kit/src/general'
import { FC, ReactNode } from 'react'

import styled from 'styled-components'

type InputSuffixProps = {
  children?: ReactNode
  hasMargin?: boolean
}

const InputSuffix: FC<InputSuffixProps> = ({ children, hasMargin }) => {
  return <StyledSuffix $hasMarginRight={hasMargin}>{children}</StyledSuffix>
}

const StyledSuffix = styled(Text)<{ $hasMarginRight?: boolean }>`
  color: ${({ theme }) => theme.color.neutral.color4};
  margin-right: ${({ $hasMarginRight }) => ($hasMarginRight ? '16px' : '0')};
`

export default InputSuffix
